import { render, staticRenderFns } from "./ParametersLayout.vue?vue&type=template&id=2a33b95c&scoped=true&"
import script from "./ParametersLayout.vue?vue&type=script&lang=js&"
export * from "./ParametersLayout.vue?vue&type=script&lang=js&"
import style0 from "./ParametersLayout.vue?vue&type=style&index=0&id=2a33b95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33b95c",
  null
  
)

export default component.exports